'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _buttons = require('@sitebase/ui-kit/es/buttons');

var _components = require('../../components');

var _common = require('../../utils/common');

var _PaymentMethod = require('../PaymentMethod');

var _PaymentMethod2 = _interopRequireDefault(_PaymentMethod);

var _CreditCardsBan = require('../CreditCardsBan');

var _CreditCardsBan2 = _interopRequireDefault(_CreditCardsBan);

var _Amount = require('../Amount');

var _Amount2 = _interopRequireDefault(_Amount);

var _apple_pay = require('../../assets/apple_pay.png');

var _apple_pay2 = _interopRequireDefault(_apple_pay);

var _AmountButtons = require('../AmountButtons');

var _AmountButtons2 = _interopRequireDefault(_AmountButtons);

var _Consent = require('../Consent');

var _Consent2 = _interopRequireDefault(_Consent);

var _ = require('../');

var _constants = require('../../constants');

var _creditCardsBan = require('../../config/creditCardsBan');

var _creditCardsBan2 = _interopRequireDefault(_creditCardsBan);

var _PresetOrOtherAmount = require('../PresetOrOtherAmount');

var _PresetOrOtherAmount2 = _interopRequireDefault(_PresetOrOtherAmount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Form component
 * @param {FormPropsType} props The properties object.
 * @returns {Element} React element
 */
var FormComponent = function (_React$Component) {
  (0, _inherits3.default)(FormComponent, _React$Component);
  (0, _createClass3.default)(FormComponent, [{
    key: 'getEditableVisibility',

    /**
     * retrieves form's editable fields visibility class
     * @param  {object} activeDeposit the current active deposit data
     * @return {string} the visibility class
     */
    value: function getEditableVisibility(activeDeposit) {
      return !activeDeposit || !activeDeposit.amount ? '' : 'hidden';
    }
  }, {
    key: 'setCountrySpecificDefaultValues',
    value: function setCountrySpecificDefaultValues() {
      var _getCountryLevelConfi = this.getCountryLevelConfig(),
          amount = _getCountryLevelConfi.amount,
          amountButtons = _getCountryLevelConfi.amountButtons;

      var updateQuickDepositInitData = this.props.updateQuickDepositInitData;

      if (!amount && !amountButtons) {
        return;
      }

      var updateObject = {};

      if (amountButtons && amountButtons.length > 0) {
        updateObject.amountButtons = amountButtons;
        this.adjustAmountButtonsForDepositLimits(updateObject);
      }
      if (amount) {
        updateObject.amount = amount;
      }

      if ((0, _keys2.default)(updateObject).length > 0) {
        updateQuickDepositInitData(updateObject);
      }
    }
  }, {
    key: 'adjustAmountButtonsForDepositLimits',
    value: function adjustAmountButtonsForDepositLimits(updateObject) {
      var amountButtons = updateObject.amountButtons;
      var _props = this.props,
          minDeposit = _props.minDeposit,
          maxDeposit = _props.maxDeposit;

      amountButtons.sort(function (a, b) {
        return +a - +b;
      });
      var maxDepositValue = +maxDeposit;
      var minDepositValue = +minDeposit;
      if (minDepositValue > maxDepositValue) {
        amountButtons[0] = minDepositValue.toString();
        this.props.updatePlayerSetAmount(true);
        return;
      }

      for (var i = 0; i < amountButtons.length; i++) {
        if (+amountButtons[i] === maxDepositValue) {
          break;
        }
        if (parseFloat(amountButtons[i]) > maxDepositValue) {
          amountButtons[i] = parseInt(maxDeposit, 10) + '';
          break;
        }
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setCountrySpecificDefaultValues();
    }
  }, {
    key: 'submitForm',
    value: function submitForm(formData) {
      if (this.props.showDepositTracker && parseFloat(formData.get('amount')) === parseFloat(this.props.maxDeposit)) {
        this.setState({ confirmDepositModalVisible: true });
        return;
      }
      this.props.onFormSubmit(formData);
    }
  }]);

  function FormComponent(props) {
    (0, _classCallCheck3.default)(this, FormComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FormComponent.__proto__ || (0, _getPrototypeOf2.default)(FormComponent)).call(this, props));

    _this.getCountryLevelConfig = function () {
      var _this$props = _this.props,
          initData = _this$props.initData,
          countryCode = _this$props.countryCode;

      if (!initData || !initData.countryLevelConfig || !countryCode || !initData.countryLevelConfig[countryCode]) {
        return {};
      }
      return initData.countryLevelConfig[countryCode];
    };

    _this.state = { confirmDepositModalVisible: false };
    return _this;
  }

  (0, _createClass3.default)(FormComponent, [{
    key: 'closeConfirmDepositModal',
    value: function closeConfirmDepositModal() {
      this.setState({ confirmDepositModalVisible: false });
    }
  }, {
    key: 'render',


    // eslint-disable-next-line complexity
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          _props2$initData = _props2.initData,
          initData = _props2$initData === undefined ? {} : _props2$initData,
          hasPlayerSetAmount = _props2.hasPlayerSetAmount,
          activeDeposit = _props2.activeDeposit,
          _props2$handleSubmit = _props2.handleSubmit,
          handleSubmit = _props2$handleSubmit === undefined ? function (formdata) {
        return formdata;
      } : _props2$handleSubmit,
          pristine = _props2.pristine,
          invalid = _props2.invalid,
          submitting = _props2.submitting,
          layout = _props2.layout,
          hasVisibleErrors = _props2.hasVisibleErrors,
          countryCode = _props2.countryCode,
          isDefaultCardChanged = _props2.isDefaultCardChanged,
          _props2$t = _props2.t,
          t = _props2$t === undefined ? function () {
        var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return function (msg) {
          return '' + ctx + msg;
        };
      } : _props2$t,
          showOtherMethods = _props2.showOtherMethods,
          isApplePayAvailable = _props2.isApplePayAvailable,
          _props2$qdConfig = _props2.qdConfig,
          qdConfig = _props2$qdConfig === undefined ? {} : _props2$qdConfig,
          showDepositTracker = _props2.showDepositTracker,
          maxDeposit = _props2.maxDeposit;


      var isVerticalLayout = layout === 'vertical';
      var showAmountButtons = isVerticalLayout && !!(initData.amountButtons && initData.amountButtons.length);
      var submitButtonTextKey = initData.submitTextKey || 'FORM_LBL_MAKE_PAYMENT';
      var submitButtonText = isApplePayAvailable ? _react2.default.createElement('img', { src: _apple_pay2.default, alt: 'Apple Pay' }) : initData.submitText || t(_constants.TRANSLATION_CONTEXT)(submitButtonTextKey);
      var submitButtonClassName = isApplePayAvailable ? 'qd-apple-btn' : 'qd-action-btn';
      var isAffectedCountry = _creditCardsBan2.default.affectedCountries.includes(countryCode);

      var _getCountryLevelConfi2 = this.getCountryLevelConfig(),
          _getCountryLevelConfi3 = _getCountryLevelConfi2.showOtherAmount,
          showOtherAmount = _getCountryLevelConfi3 === undefined ? false : _getCountryLevelConfi3;

      var isWaitingForPlayerChoice = showOtherAmount && !hasPlayerSetAmount;
      var isFormInvalid = isApplePayAvailable ? submitting : pristine || invalid || submitting;
      var isButtonDisabled = isWaitingForPlayerChoice || isFormInvalid;
      var displayConsent = (isVerticalLayout || !hasVisibleErrors) && !isApplePayAvailable;
      var displayCreditCardsBan = isAffectedCountry && isDefaultCardChanged && !isApplePayAvailable;
      var grossToNetInfo = t(_constants.TRANSLATION_CONTEXT)('GROSS_TO_NET_INFO');
      var displayGrossToNetInfo = qdConfig.jurisdiction === 'com' && countryCode === 'UK' && grossToNetInfo && grossToNetInfo.lastIndexOf(_constants.TRANSLATION_CONTEXT, 0) === -1;

      return _react2.default.createElement(
        'div',
        { className: 'qd__form-container' },
        _react2.default.createElement(
          'form',
          { className: 'qd__form' },
          _react2.default.createElement(_PaymentMethod2.default, null),
          displayGrossToNetInfo && _react2.default.createElement(_components.Info, { message: grossToNetInfo }),
          displayCreditCardsBan && _react2.default.createElement(_CreditCardsBan2.default, null),
          _react2.default.createElement(
            'section',
            { className: 'editable ' + this.getEditableVisibility(activeDeposit) },
            showOtherAmount && _react2.default.createElement(_PresetOrOtherAmount2.default, { showAmountButtons: showAmountButtons, maxDeposit: maxDeposit, t: t }),
            !showOtherAmount && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(_Amount2.default, { formElementIndex: '1' }),
              showAmountButtons && _react2.default.createElement(_AmountButtons2.default, { formElementIndex: '4' })
            ),
            showDepositTracker && _react2.default.createElement(_.DepositTracker, { jurisdiction: qdConfig.jurisdiction }),
            !isApplePayAvailable && _react2.default.createElement(_components.Cvv, {
              name: _constants.QD_RF_FIELD_CVV,
              labelText: t(_constants.TRANSLATION_CONTEXT)('FORM_LBL_CVV'),
              normalize: (0, _common.onlyNumbers)(3),
              tabIndex: '2',
              placeholder: t(_constants.TRANSLATION_CONTEXT)('FORM_LBL_CVV_PLACEHOLDER'),
              validation: [(0, _common.isRequired)(t(_constants.TRANSLATION_CONTEXT)('VAL_CVV_REQUIRED')), (0, _common.digit)(3, t(_constants.TRANSLATION_CONTEXT)('VAL_CVV_INVALID_FORMAT'))]
            }),
            _react2.default.createElement(
              _buttons.Button,
              {
                type: 'submit',
                tabIndex: '3',
                disabled: isButtonDisabled,
                onClick: handleSubmit(function (formData) {
                  return _this2.submitForm(formData);
                }),
                className: submitButtonClassName,
                outfit: 'large expanded blue',
                light: true
              },
              submitButtonText
            ),
            displayConsent && _react2.default.createElement(_Consent2.default, null),
            showOtherMethods && _react2.default.createElement(_.OtherMethodsContainer, null)
          ),
          _react2.default.createElement(_.FooterContainer, null),
          this.state.confirmDepositModalVisible && _react2.default.createElement(_.ConfirmDepositModal, {
            confirm: handleSubmit(function (formData) {
              return _this2.props.onFormSubmit(formData);
            }),
            cancel: this.closeConfirmDepositModal.bind(this)
          })
        )
      );
    }
  }]);
  return FormComponent;
}(_react2.default.Component);

exports.default = FormComponent;